import React from 'react'
interface StatusTrackingIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusTrackingIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusTrackingIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Package/Box */}
      <rect x="8" y="9" width="8" height="6" />
      {/* Tracking line */}
      <path d="M8 12l2-1.5" />
      <path d="M10 12l2 1.5" />
      <path d="M14 12l2-1.5" />
      {/* Arrow pointing outward */}
      <path d="M12 6v-2" />
      <path d="M12 20v2" />
    </svg>
  )
}
